import {Component, OnInit} from '@angular/core';
import { JhiLanguageService } from 'ng-jhipster';
import {ParametrageService} from '../../entities/parametrage/parametrage.service';
import {CONSTANTS} from '../../cadens.constants';
import {Response} from '@angular/http';
import {Parametrage} from '../../entities/parametrage/parametrage.model';
import {Register} from './register.service';

@Component({
    selector: 'jhi-register-confirmation',
    templateUrl: './register-confirmation.component.html'
})
export class RegisterConfirmationComponent implements OnInit {
    parametrage: Parametrage[];

    constructor(
        private languageService: JhiLanguageService,
        private register: Register
    ) {
        this.languageService.setLocations(['register']);
    }

    ngOnInit() {
        this.register.query().subscribe(
            (res: Response) => {
                this.parametrage = res.json();
        });
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/register/register-confirmation.component.ts